import React, { FormEvent } from 'react'
import styled from 'styled-components'
import { useFormContext, RegisterOptions } from 'react-hook-form'
import get from 'lodash/get'

import ChevronDown from 'components/icons/ChevronDown'

import FieldWrapper, { FieldProps } from './Field'

export const SelectFieldWrapper = styled.div<{
  error?: boolean
  isPlaceholder?: boolean
  rounded?: boolean
}>`
  display: inline-block;
  position: relative;
  width: 100%;
  height: 60px;
  margin-top: 8px;

  background-color: transparent;

  ${({ isPlaceholder }) =>
    isPlaceholder &&
    `
  color: #757575;
`};

  select {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    padding: 0 18px;
    padding-right: 48px;

    appearance: none;
    overflow: hidden;
    background: transparent;
    color: currentColor;
    border: 0;
    outline: 0;
    height: 100%;

    border: 1px solid
      ${({ theme, error }) =>
        error ? theme?.['-ds-error-300']?.value : theme.colors.textGreyLight};

    ${({ rounded }) =>
      rounded &&
      `
      border-radius: 6px;
    `}

    &:focus {
      border-color: ${({ theme }) => theme.brand.jungle};
    }
  }

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    pointer-events: none;
    top: 0;
    right: 0;

    height: 100%;
    padding: 0 18px;
  }

  svg {
    width: 13px;
    height: 6px;
  }
`

type Props = FieldProps & {
  placeholder?: string
  rounded?: boolean
  onChange?: (e: FormEvent) => any
  /**
   * Options to pass to the react-hook-form register function
   */
  registerOptions?: RegisterOptions
}

const SelectField: React.FC<Props> = ({
  name,
  label,
  placeholder,
  rounded = true,
  children,
  registerOptions,
  ...props
}) => {
  const {
    watch,
    formState: { errors },
    register,
  } = useFormContext()
  const error = get(errors, name)
  const value = watch(name)

  return (
    <FieldWrapper name={name} label={label}>
      <SelectFieldWrapper
        isPlaceholder={!value}
        error={!!error}
        rounded={rounded}
      >
        <select
          {...register(name, registerOptions)}
          id={name}
          name={name}
          {...props}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {children}
        </select>
        <span>
          <ChevronDown />
        </span>
      </SelectFieldWrapper>
    </FieldWrapper>
  )
}

export default SelectField
